/**
 * PatientPortalLogin — email/password fallback login for patients who
 * claimed their account. Returns the portal token and redirects.
 */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Heart, Loader2, Mail, KeyRound } from "lucide-react";

const PatientPortalLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd]     = useState("");
  const [busy, setBusy]   = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/patient-portal/login`, { email, password: pwd });
      toast.success("Bentornato 🌿");
      navigate(r.data.public_url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenziali non valide");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-teal-50 via-white to-emerald-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="w-14 h-14 mx-auto rounded-3xl bg-gradient-to-br from-teal-500 to-emerald-500 flex items-center justify-center shadow-lg">
            <Heart className="w-6 h-6 text-white" />
          </div>
          <h1 className="text-2xl font-black text-slate-900 mt-3">Il tuo recovery</h1>
          <p className="text-xs text-slate-500 mt-1">Accedi con email e password</p>
        </div>

        <form onSubmit={submit} className="rounded-3xl bg-white shadow-xl border border-slate-200/60 p-6 space-y-3">
          <div>
            <label className="text-[10px] uppercase tracking-wider font-bold text-teal-600 mb-1 inline-flex items-center gap-1">
              <Mail className="w-3 h-3" /> Email
            </label>
            <Input
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              required autoComplete="email"
              data-testid="portal-login-email"
              className="rounded-2xl"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-wider font-bold text-teal-600 mb-1 inline-flex items-center gap-1">
              <KeyRound className="w-3 h-3" /> Password
            </label>
            <Input
              type="password" value={pwd}
              onChange={e => setPwd(e.target.value)}
              required autoComplete="current-password"
              data-testid="portal-login-password"
              className="rounded-2xl"
            />
          </div>
          <Button
            type="submit"
            disabled={busy || !email || !pwd}
            className="w-full rounded-full bg-gradient-to-r from-teal-500 to-emerald-500 text-white py-5"
            data-testid="portal-login-submit"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Entra nel portale"}
          </Button>
        </form>

        <p className="text-xs text-slate-400 text-center mt-4">
          Non hai un account? Chiedi il link magico al tuo professionista.
        </p>
      </div>
    </div>
  );
};

export default PatientPortalLogin;
